import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import * as schemas from '../schemas';
import {
  DeleteFromLifecycleDoNotContactListDocument,
  DeleteFromLifecycleDoNotContactListMutationResult,
  GetLifecycleSurveyDoNotContactListDocument,
  GetLifecycleSurveyDoNotContactListQueryResult,
  OutputLifecycleSurveyDoNotContactList,
} from '~/gql/graphql';
import {
  lifecycleSurveyDoNotContactListTransformer,
  TransformedLifecycleSurveyDoNotContactList,
} from '../transformers/lifecycleSurveyDoNotContactList.transformer';

const getLifecycleSurveyDoNotContactList = createAsyncThunk(
  'lifecycleSurveyDoNotContactList/getLifecycleSurveyDoNotContactList',
  async (_, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<GetLifecycleSurveyDoNotContactListQueryResult>(
        GetLifecycleSurveyDoNotContactListDocument,
      );

      if (!res.data?.getLifecycleSurveyDoNotContactList) return rejectWithValue(res);

      const list = res.data.getLifecycleSurveyDoNotContactList as OutputLifecycleSurveyDoNotContactList[];
      const transformedList = list.map(lifecycleSurveyDoNotContactListTransformer);

      return normalize(transformedList, [schemas.lifecycleSurveyDoNotContactList]);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const deleteFromLifecycleDoNotContactList = createAsyncThunk(
  'lifecycleSurveyDoNotContactList/deleteFromLifecycleDoNotContactList',
  async (employee: TransformedLifecycleSurveyDoNotContactList, { rejectWithValue }) => {
    try {
      const res = await graphqlRequest<DeleteFromLifecycleDoNotContactListMutationResult>(
        DeleteFromLifecycleDoNotContactListDocument,
        {
          employeeId: employee.employeeId,
        },
      );

      if (!res.data?.deleteFromLifecycleDoNotContactList) return rejectWithValue(res);

      return { id: employee.id };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const lifecycleSurveyDoNotContactListActions = {
  getLifecycleSurveyDoNotContactList,
  deleteFromLifecycleDoNotContactList,
};
